import { enUS, ar, es, fi, id, ja, ko, nl, nb, ro, sv, th, tr, uk, zhCN, ptBR, fr, it, de, pl, cs, da, el, pt } from "date-fns/locale";

export const EEACountries: string[] = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "IS", "LI", "NO", "CH", "GB"];

export const devIdCookieName = "u-dev-id";
export const routeCookieName = "visit-route";
export const defaultLocale = "en-US";
export const fallback_user_id = "fallback_d1wc";

export const languages = [
	{ locale: "en-US", lang: "en", name: "English", dateLocale: enUS },
	{ locale: "ar-AE", lang: "ar", name: "Arabic (العربية)", dateLocale: ar },
	{ locale: "cs-CZ", lang: "cs", name: "Czech (Čeština)", dateLocale: cs },
	{ locale: "da-DK", lang: "da", name: "Danish (Dansk)", dateLocale: da },
	{ locale: "de-DE", lang: "de", name: "German (Deutsch)", dateLocale: de },
	{ locale: "el-GR", lang: "el", name: "Greek (Ελληνικά)", dateLocale: el },
	{ locale: "es-ES", lang: "es", name: "Spanish (Español)", dateLocale: es },
	{ locale: "fi-FI", lang: "fi", name: "Finnish (Suomi)", dateLocale: fi },
	{ locale: "fr-FR", lang: "fr", name: "French (Français)", dateLocale: fr },
	{ locale: "id-ID", lang: "id", name: "Indonesian (Bahasa Indonesia)", dateLocale: id },
	{ locale: "it-IT", lang: "it", name: "Italian (Italiano)", dateLocale: it },
	{ locale: "ja-JP", lang: "ja", name: "Japanese (日本語)", dateLocale: ja },
	{ locale: "ko-KR", lang: "ko", name: "Korean (한국어)", dateLocale: ko },
	{ locale: "nl-NL", lang: "nl", name: "Dutch (Nederlands)", dateLocale: nl },
	{ locale: "no-NO", lang: "no", name: "Norwegian (Norsk)", dateLocale: nb },
	{ locale: "pl-PL", lang: "pl", name: "Polish (Polski)", dateLocale: pl },
	{ locale: "pt-BR", lang: "pt", name: "Portuguese (Português Brazil)", dateLocale: ptBR },
	{ locale: "pt-PT", lang: "pt", name: "Portuguese (Português)", dateLocale: pt },
	{ locale: "ro-RO", lang: "ro", name: "Romanian (Română)", dateLocale: ro },
	{ locale: "sv-SE", lang: "sv", name: "Swedish (Svenska)", dateLocale: sv },
	{ locale: "th-TH", lang: "th", name: "Thai (ไทย)", dateLocale: th },
	{ locale: "tr-TR", lang: "tr", name: "Turkish (Türkçe)", dateLocale: tr },
	{ locale: "uk-UA", lang: "uk", name: "Ukrainian (Українська)", dateLocale: uk },
	{ locale: "zh-CN", lang: "zh", name: "Chinese (中文)", dateLocale: zhCN },
];

export const contactEmail = `support+rent80@discounts70.com`;
export const contactAddress = `Lascade LLC\nSharjah Media City, Sharjah\nAsh Shariqah [Sharjah]\n00000\nUnited Arab Emirates`;
export const supportUpdateDate = new Date(new Date().getFullYear(), new Date().getMonth() - 2, 26).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
